import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { parse } from "cookie";
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService{

  public socket;
  COOKIE_NAME = "AWSALB";

  constructor(storage: StorageService) {

    this.socket = (io as any)(environment.apiUrl);

    this.socket.io.on("open", () => {
      this.socket.io.engine.transport.on("pollComplete", () => {
        const request = this.socket.io.engine.transport.pollXhr.xhr;
        const cookieHeader = request.getResponseHeader("set-cookie");
        if (!cookieHeader) {
          return;
        }
        cookieHeader.forEach((cookieString:any) => {
          if (cookieString.includes(`${this.COOKIE_NAME}=`)) {
            const cookie = parse(cookieString);
            this.socket.io.opts.extraHeaders = {
              cookie: `${this.COOKIE_NAME}=${cookie[this.COOKIE_NAME]}`
            }
          }
        });
      });
    });

    /*super({ url: environment.apiUrl, options: {query: {
      api: 'testapi'
    }} });*/
  }
}
